import { Tooltip, Anchor, Badge } from "@mantine/core";
import styles from "./AIChatCitationMarker.module.css";
import { useState } from "react";
import { useClickOutside } from "@mantine/hooks";

interface AIChatCitationMarkerProps {
	href: string;
	title: string;
	label: string;
}

export default function AIChatCitationMarker({ href, title, label }: AIChatCitationMarkerProps) {
	const ref = useClickOutside(() => setForceOpen(false));
	const [forceOpen, setForceOpen] = useState(false);
	const forceOpenProp = forceOpen ? { opened: forceOpen } : {};

	return (
		<Tooltip
			className={styles.root}
			ref={ref}
			{...forceOpenProp}
			label={
				<Anchor
					href={href}
					target="_blank"
					rel="noopener"
					underline="never"
					style={{ color: "inherit" }}
				>
					{title}
				</Anchor>
			}
		>
			<Anchor
				href={href}
				target="_blank"
				rel="noopener"
				onTouchEnd={(e: React.TouchEvent<HTMLAnchorElement>) => {
					if (!forceOpen) {
						e.preventDefault();
						setForceOpen(true);
					}
				}}
			>
				<Badge circle>{label}</Badge>
			</Anchor>
		</Tooltip>
	);
}
